import { ButtonProps } from './model';
import { ButtonView } from './view';

export const Button = (props: ButtonProps) => {
    return ButtonView(props);
};
